import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { IconX } from '@tabler/icons-react';
import TripItineraryContent from './TripItineraryContent';

interface TripItineraryModalProps {
  open: boolean;
  onClose: () => void;
  tripId: number;
}

const TripItineraryModal: React.FC<TripItineraryModalProps> = ({
  open,
  onClose,
  tripId,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <div className="flex justify-between items-center">
          <span className="text-2xl text-neutral-800 font-semibold">
            Trip itinerary
          </span>
          <IconButton onClick={onClose} aria-label="Close itinerary">
            <IconX size={24} />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent dividers className="custom-scrollbar">
        <TripItineraryContent tripId={tripId} enabled={open} />
      </DialogContent>

      <div className="w-full flex items-center justify-end h-[77px] bg-neutral-00 border-t border-neutral-200">
        <button
          type="button"
          className="border py-3 px-6 h-[45px] mr-6 border-neutral-800 rounded-lg text-neutral-800 font-semibold"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default TripItineraryModal;
